export default __webpack_public_path__ + "static/media/logo_ISO_9001-2015.7ca4b2e4.jpg";